var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "selector-title font-weight-bold" }, [
      _vm._v(_vm._s(_vm.title)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body mt-2 p-0" }, [
      !_vm.variants
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c("b-spinner", {
                attrs: { variant: "primary", label: "Loading variants" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.variants && _vm.variants.length
        ? _c(
            "div",
            [
              _c(_setup.BTable, {
                ref: "variantsTable",
                staticClass: "w-100 h-100 variants-table",
                attrs: {
                  "table-class": "h-100",
                  striped: "",
                  hover: "",
                  items: _vm.variants,
                  fields: _setup.variantTableFields,
                  responsive: "sm",
                  "select-mode": "multi",
                  selectable: !_setup.hasDetailsView,
                },
                on: { "row-selected": _setup.onRowSelected },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(name)",
                      fn: function (data) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "row-wrapper",
                              class: _setup.getRowClasses(data),
                              on: {
                                click: function ($event) {
                                  data.toggleDetails()
                                  _setup.onDetailsVisibilityChange(data)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "row-content" }, [
                                data.item.image
                                  ? _c(
                                      "div",
                                      { staticClass: "d-inline" },
                                      [
                                        _c(
                                          "b-img",
                                          _vm._b(
                                            {
                                              attrs: {
                                                rounded: "",
                                                thumbnail: "",
                                                src: data.item.image,
                                              },
                                            },
                                            "b-img",
                                            _setup.thumbsProps,
                                            false
                                          )
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "ml-3 variant-name d-inline" },
                                  [_vm._v(_vm._s(data.item.name))]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(price)",
                      fn: function (data) {
                        return [
                          data.item.price
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "align-items-center d-flex h-100 justify-content-end row-wrapper",
                                  on: {
                                    click: function ($event) {
                                      data.toggleDetails()
                                      _setup.onDetailsVisibilityChange(data)
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "row-content" }, [
                                    _c("b", [
                                      _vm._v("$" + _vm._s(data.item.price)),
                                    ]),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "row-details",
                      fn: function ({ item }) {
                        return [
                          _c("div", { staticClass: "row-wrapper" }, [
                            _c(
                              "div",
                              { staticClass: "row-content" },
                              [_vm._t("row-details", null, { data: item })],
                              2
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.variants && !_vm.variants.length
        ? _c("div", [_vm._v("No variants available")])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.showDoneButton
      ? _c(
          "button",
          {
            staticClass: "btn btn-primary float-right",
            on: { click: _setup.onDone },
          },
          [_vm._v("Done")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }